module.exports = __webpack_public_path__ + "static/media/speaker.9f3d2f60.png";